import { serialize, update } from "serializr";
import { ApiService } from "../api";
import { Payment } from "../payments";
import { Application } from "./Application";

/**
 * Functions for fetching applications.
 */
export class ApplicationService {
	protected apiService: ApiService;

	constructor() {
		this.apiService = new ApiService();
	}

	public async getApplicationByApplicationId(
		applicationId: string,
		email: string,
		application: Application,
	): Promise<Application | boolean> {
		const response = await this.apiService.get(
			`/api/v1/application/get-by-application-id`,
			{
				application_id: applicationId,
				email,
			},
		);

		if (response.status === 200) {
			const applicationJson = await response.json();
			update(application, applicationJson);
			return application;
		}

		return false;
	}

	public async createApplication(
		application: Application,
	): Promise<Application> {
		const applicationData = await this.apiService.post(
			`/api/v1/application/create`,
			serialize(Application, application),
		);

		const applicationJson = await applicationData.json();
		update(application, applicationJson);
		return application;
	}

	public async updateApplication(
		application: Application,
		submit?: boolean,
	): Promise<Application> {
		let params = "";
		if (submit) {
			params = "?submit=true";
		}
		const applicationData = await this.apiService.post(
			`/api/v1/application/update${params}`,
			serialize(Application, application),
		);

		const applicationJson = await applicationData.json();
		update(application, applicationJson);
		return application;
	}

	public async uploadFiles(
		application: Application,
		files: File[],
		prefix: string,
	): Promise<Application> {
		const formData = new FormData();

		for (const file of files) {
			formData.append("attachments[]", file, `${prefix}-${file.name}`);
		}

		formData.append("application_id", String(application.applicationId));

		const applicationData = await this.apiService.uploadFile(
			`/api/v1/application/upload`,
			formData,
		);

		const applicationJson = await applicationData.json();
		update(application, applicationJson);
		return application;
	}
	public async submitProofOfPayment(
		payment: Payment,
		files?: File[],
	): Promise<Payment> {
		const formData = new FormData();

		if (files) {
			for (const file of files) {
				formData.append("attachments[]", file, file.name);
			}
		}

		formData.append("payment", JSON.stringify(serialize(payment)));

		await this.apiService.uploadFile(
			`/api/v1/application/submit-payment`,
			formData,
		);

		return payment;
	}
}
